// src\routes\publicRoutes.tsx
import React, { lazy, Suspense } from "react";
import Loader from "../components/CustomLoader";
import { Navigate, RouteObject } from "react-router-dom";


const About = lazy(() => import("../pages/Public/About"));
// const NotFound = lazy(() => import("../pages/Public/NotFound"));
const Alldesigns = lazy(() => import("../pages/Public/styles/Alldesigns"));
const Design2 = lazy(() => import("../pages/Public/styles/Design2"));
const Design3 = lazy(() => import("../pages/Public/styles/Design3"));
const Design4 = lazy(() => import("../pages/Public/styles/Design4"));
const Design5 = lazy(() => import("../pages/Public/styles/Design5"));
const ChatPage = lazy(() => import("../pages/Public/ChatPage"));
const FeedbackForm = lazy(() => import("../pages/Public/FeedbackForm"));
const ThankYou = lazy(() => import("../pages/Public/ThankYou"));
const AddSubscription = lazy(() => import("../pages/Public/AddNewSubscription"));
const VerifyReslove = lazy(() => import("../pages/Public/VerifyReslove"));
const SubscriptionSuccess = lazy(() => import("../pages/SuperVisor/SubscriptionSuccess"));
// const KnowledgeBase = lazy(() => import("../pages/Public/KnowledgeBase"));


const withSuspense = (Component: React.FC) => (
    <Suspense fallback={<Loader force={true} />}>
        {/* <Suspense fallback={<LoaderFallback />}> */}
        <Component />
    </Suspense>
);


export const publicRoutes: RouteObject[] = [
    { path: "/about", element: withSuspense(About) },
    { path: "/design", element: withSuspense(Alldesigns) },
    { path: "/design2", element: withSuspense(Design2) },
    { path: "/design3", element: withSuspense(Design3) },
    { path: "/design4", element: withSuspense(Design4) },
    { path: "/design5", element: withSuspense(Design5) },
    { path: "/chatbot/:chatbotId", element: withSuspense(ChatPage) },
    { path: "/feedback/:token", element: withSuspense(FeedbackForm) },
    { path: "/thank-you", element: withSuspense(ThankYou) },
    { path: "/resolve", element: withSuspense(VerifyReslove) },
    { path: "/add-new-subscription", element: withSuspense(AddSubscription) },
    { path: "/subscription/payment-callback", element: withSuspense(SubscriptionSuccess) },
    // { path: "/knowledge-base", element: withSuspense(KnowledgeBase) },

    // { path: "*", element: <NotFound />  },
    { path: "*", element: <Navigate to="/" replace /> },
]
